import React from "react";

function PreparingWorkspace(props) {
  

  return (
    <React.Fragment>
      <div className="container" data-testid="workspace-preparing">
        <div className="row">&nbsp;</div>
        <div className="row">&nbsp;</div>
        {/*
          Dark pass 2026-09-09 (re-ink only — same bootstrap markup, no DS migration).
          `.alert-primary` and `.bg-white` were the whole light-only look: they painted
          Bootstrap's blue-on-#cfe2ff alert (bg-white is `!important`, so it cannot be
          out-cascaded — the class has to go). The `.alert` box (padding, radius, 1px
          border) stays; colour now rides the role tokens so the card themes with the
          shell. The spinner ring is `currentColor`, so its ink is the accent token.
        */}
        <div
          className="alert tw-bg-surface tw-border-edge tw-text-ink"
          role="alert"
          data-testid="workspace-preparing-card"
        >
          <div className="row">
            <h4 className="alert-heading tw-text-ink" data-testid="workspace-preparing-title">
              <div
                className="spinner-border tw-text-accent"
                role="status"
                data-testid="workspace-preparing-spinner"
              >
                <span className="sr-only">Loading...</span>
              </div>
              &nbsp;&nbsp;&nbsp;Welcome. We are preparing or switching your
              workspace
            </h4>
          </div>
          <p className="tw-text-ink-secondary" data-testid="workspace-preparing-message">
            Please be patient while we do so. We will take you to your dashboard
            once we are done.
          </p>
          {/* Bootstrap 5 paints <hr> as `background: currentColor; opacity: .25` —
              on token ink that is a faint smear in both themes, so the rule takes
              the edge token at full opacity instead. */}
          <hr className="tw-bg-edge tw-opacity-100" />
          {/* <p className="mb-0">
            If you are the admin , Please visit admin section and associate few
            workspace for the selected workspace or party. Please click&nbsp;
            <a
              style={{ cursor: "pointer" }}
              onClick={() => history.push("admin/dashboard")}
            >
              here
            </a>
            &nbsp;to got to admin side
          </p>
          <br />
          <p className="mb-0">
            If you are lost , Please click&nbsp;
            <a href="/login">here</a>&nbsp;to login back
          </p> */}
        </div>
      </div>
    </React.Fragment>
  );
}

export default PreparingWorkspace;
